/* eslint-disable no-console */
import { useEffect, useRef } from 'react';

/**
 * Hook específico para manejar el evento onIncomingCallAlreadyAnswered del SDK de Fonema.
 *
 * Se dispara cuando una llamada entrante fue contestada en otra pestaña/navegador.
 * - Limpia referencias globales si corresponde.
 * - Cierra el componente de llamada si está montado.
 */
const useFonemaOnIncomingCallAlreadyAnswered = ({ onClose, enabled = true }) => {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!enabled) return undefined;

    let unsubscribeIncomingCallAlreadyAnswered;

    if (window.FonemaWhatsappAudio?.onIncomingCallAlreadyAnswered) {
      console.log('Subscribing to onIncomingCallAlreadyAnswered event (useFonemaOnIncomingCallAlreadyAnswered)');
      unsubscribeIncomingCallAlreadyAnswered = window.FonemaWhatsappAudio.onIncomingCallAlreadyAnswered(
        (callId) => {
          console.log('Call was answered by another tab/browser', callId);
          if (typeof onCloseRef.current === 'function') {
            onCloseRef.current(callId);
          }
        }
      );
    }

    return () => {
      console.log(
        'Cleaning up onIncomingCallAlreadyAnswered listener in useFonemaOnIncomingCallAlreadyAnswered'
      );
      if (
        unsubscribeIncomingCallAlreadyAnswered
        && typeof unsubscribeIncomingCallAlreadyAnswered === 'function'
      ) {
        console.log('Unsubscribing from onIncomingCallAlreadyAnswered event');
        unsubscribeIncomingCallAlreadyAnswered();
      }
    };
  }, [onCloseRef, enabled]);
};

export default useFonemaOnIncomingCallAlreadyAnswered;
